import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function LeaderAdultCareLevel5() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    LEADER IN ADULT CARE
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    APPRENTICESHIP LEVEL 5
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Overview of the role */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Overview of the role:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Leading the care service and managing teams of carers to look after adults with care needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Details of standard */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Details of standard:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    The Leader in Adult Care will guide and inspire teams to make positive differences to someone's life when they are faced with physical, practical, social, emotional, psychological or intellectual challenges. They will be a leader of the care team and will develop and implement a values-based culture at a service or unit level. They may be responsible for business development, financial control, organisational resilience and continuity as well as for managing risk and leading on organisational change.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    <strong>A Leader in Adult Care</strong> has responsibility for managing community or residential based services. This role has a large element of leadership, whether with other care workers and networks or in leading the service itself. A successful apprentice will have met all the requirements. They have a responsibility to ensure the service is safe, effective, caring, responsive to people's needs and well-led. They may be a registered manager of a service, unit, deputy or assistant manager. They will be responsible for ensuring regulatory compliance of the care given and the values and training of staff with established standards and regulations.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    These are the personal attributes and behaviours expected of all Leaders in Adult Care carrying out their roles:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '20px', marginBottom: '25px' }}>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Care</strong> – is caring consistently and enough about individuals to make a positive difference to their lives
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Compassion</strong> – is delivering care and support with kindness, consideration, dignity, empathy and respect
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Courage</strong> – is doing the right thing for people and speaking up if the individual they support is at risk
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Communication</strong> – good communication is central to successful caring relationships and effective team working
                    </li>
                    <li style={{ marginBottom: '15px' }}>
                      <strong>Competence</strong> – is applying knowledge and skills to provide high quality care and support
                    </li>
                    <li style={{ marginBottom: '0' }}>
                      <strong>Commitment</strong> – to improving the experience of people who need care and support ensuring it is person centred
                    </li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    Leaders in Adult Care may work in residential or nursing homes, domiciliary care, community day centres, a person's own home or some clinical healthcare settings. The role of Leader in Adult Care in this standard also covers Personal Assistants who operate in a management role, but they may only work directly for one individual who needs support and/or care services.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    <strong>Typical job titles</strong> include registered, assistant, deputy, unit or service manager.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Qualifications */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Qualifications:
                  </h3>
                  
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '20px', marginBottom: '25px' }}>
                    <li>Level 5 Diploma in Leadership and Management for Adult Care.</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    Awarding Organisations: <strong>NCFE, TQUK.</strong>
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '20px', marginBottom: '0' }}>
                    <li style={{ marginBottom: '15px' }}>
                      Apprentices without level 2 English and maths will need to achieve this level prior to completion of their Apprenticeship.
                    </li>
                    <li style={{ marginBottom: '0' }}>
                      For those with an education, health and care plan or a legacy statement the apprenticeships English and maths minimum requirement is Entry Level 3 and British Sign Language qualification are an alternative to English qualifications for whom this is their primary language.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Duration */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Duration:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Typically, 18 months
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Level */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Level:
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    5
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Industry-specific requirements */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Industry-specific requirements:
                  </h3>
                  
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', paddingLeft: '20px', marginBottom: '0' }}>
                    <li>Undertake the Disclosure and Barring Service process and provide the result.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default LeaderAdultCareLevel5;